<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 32.46 32.46" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="10"><path d="m9.34.5h-8.84v8.36"/><path d="m.5.5 12.64 12.64"/><path d="m23.12 32h8.88v-8.4"/><path d="m32 32-12.69-12.69"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
